module.exports = __webpack_public_path__ + "img/cert5.4ca7f23e.png";